/* eslint-disable no-undef */
"use strict";

const autoScrollOffset = () => {
  (($) => {
    const el = {
      stickyEl: ".elementor .elementor-sticky",
    };

    const init = () => {
      $(document).ready(function () {
        exec();
      });
    };

    const exec = () => {
      // overwrite woocommerce scroll to notices
      $.scroll_to_notices = function (scrollElement) {
        var offset = $(el.stickyEl)
          .map((_, el) => $(el).outerHeight()) // only get visible element
          .get()
          .filter((e, i, self) => self.indexOf(e) === i) // Get unique value, Elementor Sticky have duplicate element
          .reduce((acc, val) => acc + val, 0); // Get sum of all value

        if (scrollElement.length) {
          setTimeout(() => {
            $("html, body").animate(
              {
                scrollTop: scrollElement.offset().top - offset - 40, // add offset
              },
              1000
            );
          }, 1);
        }
      };
    };

    init();
    // eslint-disable-next-line no-undef
  })(jQuery);
};

try {
  autoScrollOffset();
} catch (error) {
  console.error(error);
}
